import styled from "styled-components";

export const InctBalance = styled.div`
  background: linear-gradient(90deg, rgba(112, 218, 188, 0.45) 0%, #ECFFFA 100%);
  padding: 11px 16px 11px 54px;
  display: flex;
  align-items: center;
  @media (max-width: 768px) {
    padding: 11px 16px 11px 47px;
  }
`;
export const InctBalanceLeft = styled.div`
  flex: 1;
`;
export const InctBalanceRight = styled.div`
  flex-shrink: 0;
  margin-left: 20px;
`;
export const InctBalanceHeading = styled.h4`
  font-size: 12px;
  font-weight: 900;
  color: #000;
`;
export const InctBalanceSubHeading = styled.p`
  font-size: 10px;
  line-height: 12px;
  font-weight: 400;
  color: #000;
`;
export const InctBalancePrice = styled.p`
  font-size: 12px;
  font-weight: 900;
  color: #198B7D;
`;